import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useMeterReading} from "../hooks/useMeterReading.ts";
import {MeterReading} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {
        createRecord,
    } = useMeterReading();

    return (
        <FormDrawer
            record={{
                id: '',
                meterValue: 0,
                timestamp: '',
            } as MeterReading}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
